import React from 'react';
import { Link } from 'react-router-dom';

import './About.css';

function About() {
    return (
        <div className="container lighter-background">
            <div className="row">
                <div className="col col-8 col-expand text-left hero">
                    <div className="mobile-only center-on-mobile">
                        <div className="img-responsive user-avatar">
                            <img src={'/assets/imgs/bg3-original.jpg'} alt="Omar Quazi portrait" />
                        </div>
                    </div>
                    <h1 className="display-4 text-bold text-indigo center-on-mobile">About</h1>
                    <p className="lead">
                        I’m Omar Quazi, a product-minded software engineer based in Toronto. I build secure, reliable web and mobile systems across authentication, backend services, APIs, and customer-facing product experiences.
                    </p>
                    <p className="lead">
                        I currently work at Okta, where I contribute to identity and login experiences used in security-sensitive production environments. My work tends to sit where product quality, developer experience, and operational reliability meet.
                    </p>
                    <p className="lead">
                        You can view my <a href="https://www.linkedin.com/in/omarquazi" target="_blank" rel="noreferrer">LinkedIn</a>, read through my <Link to="/resume">resume</Link>, or explore selected work on the <Link to="/portfolio">portfolio</Link> page.
                    </p>
                </div>
                <div className="col col-4 col-expand desktop-only">
                    <div className="img-responsive h-100 bottom-align">
                        <img src={'../../assets/imgs/bg3.png'} alt="Omar standing in a black and white portrait" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
